import globalAxios from "../GlobalAxios";

const groupListApi = async () => {
  const res = await globalAxios.get("/api/playlist/grouplist");
  return res.data.lists;
};

const playListApi = async (groupId, page = 1) => {
  //console.log('id', groupId);
  const res = await globalAxios.get(`/api/playlist/playlists?group_id=${groupId}&page=${page}&per_page=10`);
  return res.data;
};

const allPlaylistApi = async (page, itemsPerPage, searchQuery) => {
  const res = await globalAxios.get(`/api/playlist/playlistall?group_id=all&page=${page}&per_page=${itemsPerPage}&query=${searchQuery}`)
  return res.data;
};

// const searchPlaylistApi = async (page, itemsPerPage, query) => {
//   const res = await globalAxios.get(`/api/playlist/playlistsearch?group_id=all&page=${page}&per_page=${itemsPerPage}&query=${query}`)
//   return res.data;
// };

const groupListPagingApi = async () => {
  const res = await globalAxios.get("/api/playlist/grouplistpaging");
  return res.data.lists;
};

const addPlaylistGroup = async (data) => {
  const res = await globalAxios.post("/api/playlist/addgroup", data);
  return res.data;
};

const deletePlaylistGroup = async (id) => {
  const res = await globalAxios.delete(`/api/playlist/deletegroup/${id}`);
  return res.data;
};

const groupingAsset = async (data) => {
  const res = await globalAxios.post("/api/playlist/groupingItems", data);
  return res.data;
};

const groupDrag = async (data) => {
  const res = await globalAxios.post("/api/playlist/updategrouporder", data);
  return res.data;
};

const playlistDrag = async (data) => {
  const res = await globalAxios.post("/api/playlist/updateplaylistorder", data);
  return res.data;
};

const addPlaylist = async (data) => {
  const res = await globalAxios.post("/api/playlist/groupingaddditems", data);
  return res.data;
};

const playlistUUid = async (id) => {
  const res = await globalAxios.get(`/api/playlist/playlistuuid/${id}`)
  return res.data;
}

const modalplaylist = async (uuid) => {
  const res = await globalAxios.get(`/api/playlist/player/${uuid}`)
  return res.data;
}

const deletePlaylistItem = async (data) => {
  const res = await globalAxios.delete(`/api/playlist/deleteitem`, { data });
  return res.data;
}

const modifyGroupName = async (data) => {
  const res = await globalAxios.post("/api/playlist/groupmodify", data);
  return res.data;
}


export default {
  groupListApi,
  playListApi,
  allPlaylistApi,
  groupListPagingApi,
  addPlaylistGroup,
  deletePlaylistGroup,
  groupingAsset,
  groupDrag,
  playlistDrag,
  addPlaylist,
  playlistUUid,
  modalplaylist,
  deletePlaylistItem,
  modifyGroupName,
  // searchPlaylistApi
};